const identifyUser = (user) => {
	try {
		if (window._cio) {
			window._cio.identify({
				// Required attributes — you must include your customer's identifier (this can be either an email address or a unique ID value) in a property named "id"
				id: user.email,

				// Other attributes (properties you'll reference with liquid)
				email: user.email,
				first_name: user.first_name,
				last_name: user.last_name,
			});
		}
	} catch (err) {
		console.log(err);
	}
};
export default { identifyUser };
